/**
 * localStorage hook met automatische serialisatie en migration-safe keys.
 * Volgens Steven's spec: `motera_baseline_<token>` / `motera_followup_<token>_week<X>`.
 */
import { useCallback, useEffect, useRef, useState } from "react";

export function useLocalStorageState(key, initialValue) {
  const [value, setValue] = useState(() => {
    if (typeof window === "undefined") return initialValue;
    try {
      const raw = window.localStorage.getItem(key);
      if (raw === null) return initialValue;
      return JSON.parse(raw);
    } catch {
      return initialValue;
    }
  });

  const keyRef = useRef(key);
  useEffect(() => {
    keyRef.current = key;
  }, [key]);

  useEffect(() => {
    try {
      window.localStorage.setItem(keyRef.current, JSON.stringify(value));
    } catch {
      /* quota etc — silent */
    }
  }, [value]);

  const remove = useCallback(() => {
    try {
      window.localStorage.removeItem(keyRef.current);
    } catch {
      /* silent */
    }
  }, []);

  return [value, setValue, remove];
}

export function hasStoredProgress(key) {
  try {
    return window.localStorage.getItem(key) !== null;
  } catch {
    return false;
  }
}
